export const validateTextField = (name, min, max, fieldName = "Field") => {
    const trimmedName = name.trim();
    const validNameRegex = /^[A-Za-z0-9_ ]+$/;
    let error = "";

    if (!trimmedName) {
        error = `${fieldName} is required.`;
        return { isValid: false, error };
    }

    // if (!validNameRegex.test(trimmedName)) {
    //     error = `${fieldName} should not contain special characters.`;
    //     return { isValid: false, error };
    // }

    // if (/^\d+$/.test(trimmedName)) {
    //     error = `${fieldName} should not contain only numbers.`;
    //     return { isValid: false, error };
    // }

    if (trimmedName.length < min) {
        error = `${fieldName} must have a minimum of ${min} characters.`;
        return { isValid: false, error };
    }

    if (trimmedName.length > max) {
        error = `${fieldName} can have a maximum of ${max} characters.`;
        return { isValid: false, error };
    }

    return { isValid: true, error: "" };
};
